function toggleBodyClassBasedOnSearchModal() {
    const searchModal = document.querySelector('.search-modal__content');
    
    if (searchModal?.hasAttribute('open')) {
      document.body.classList.add('search-open');
    } else {
      document.body.classList.remove('search-open');
    }
  }
    document.addEventListener('DOMContentLoaded', toggleBodyClassBasedOnSearchModal);
  const searchModal = document.querySelector('.search-modal__content');
  if (searchModal) {
    const observer = new MutationObserver(() => {
      toggleBodyClassBasedOnSearchModal();
    });
    observer.observe(searchModal, { attributes: true, attributeFilter: ['open'] });
  }